module.exports = __webpack_public_path__ + "static/img/country.c6fbd58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country.png
// module id = PjSy
// module chunks = 1